// Module
var code = "<div class=\"body\"> <header-error/> <router-view/> <loading/> <modal-message/> </div> ";
// Exports
export default code;